import * as SponsorStore from '../../../../redux/middleware/SponsorMiddleware';
import { AppState } from '../../../../redux/reducers';
import { Sponsor } from '../../../../models/Entities/Sponsor/Sponsor';

interface IProps {
  selectionLimit: number;
  onChangeSelection?: (selected: Sponsor | Sponsor[]) => void;
  initialSponsorId?: number;
}

interface ConnectedProps {
  isLoading: boolean;
  sponsors: Sponsor[];
}

interface DispatchProps {
  GetAllSponsors: typeof SponsorStore.actionCreators.GetAllSponsors;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.Sponsor?.isLoadingAll ?? false,
  sponsors: state.Sponsor?.list ?? [],
});

export const mapDispatchToProps = {
  ...SponsorStore.actionCreators,
};
